import { Component, inject } from '@angular/core';
import { PageHeaderComponent } from '@core/components/page-header/page-header.component';
import { OverlayService, SignalButton, ToastService } from '@vallift/ngl';
import { SlashCaretDemoComponent } from './slash-caret-demo/slash-caret-demo';
import { ToastTestConfirmOverlayComponent } from './toast-test-confirm-overlay';

@Component({
  selector: 'app-toast-test-page',
  standalone: true,
  imports: [PageHeaderComponent, SignalButton, SlashCaretDemoComponent],
  templateUrl: './toast-test-page.html',
})
export class ToastTestPage {
  private readonly toast = inject(ToastService);
  private readonly overlay = inject(OverlayService);

  openConfirmPopup(): void {
    this.overlay.openModal(ToastTestConfirmOverlayComponent, {
      fitContent: true,
      panelClass: ['confirm-overlay-panel'],
    });
  }

  showSuccessTitleOnly(): void {
    this.toast.success('', { title: 'Key copied' });
  }

  showSuccessTitleAndMessage(): void {
    this.toast.success('You can paste it wherever you need it.', { title: 'Key copied' });
  }

  showErrorTitleOnly(): void {
    this.toast.error('', { title: 'Something went wrong' });
  }

  showErrorTitleAndMessage(): void {
    this.toast.error('Please try again.', { title: 'Something went wrong' });
  }

  showInfoTitleOnly(): void {
    this.toast.info('', { title: 'Heads up' });
  }

  showInfoTitleAndMessage(): void {
    this.toast.info('Your changes are saved automatically.', { title: 'Heads up' });
  }

  showWarningTitleOnly(): void {
    this.toast.warning('', { title: 'Be careful' });
  }

  showWarningTitleAndMessage(): void {
    this.toast.warning('This action cannot be undone.', { title: 'Be careful' });
  }
}
